import 'rxjs/add/operator/toPromise';
import {Injectable} from '@angular/core';

import {Storage} from '@ionic/storage';

import {App, Modal, ModalController, NavController, Tabs, Tab, Events, Platform} from "ionic-angular";
import {MainPage} from "../../pages/pages";

import {ApiService} from "../api-service/api-service";
import {AppConfig} from "../../app/app.config";
declare let window: any;

@Injectable()
export class UserService {

  public boot_banner: any = [];
  public search_keyword: any = '';

  private _defaults: any;
  public _user: any;
  // public remembphone: any = '';
  public BOOT_IMG_KEY: string = '_boot_img';
  public SETTINGS_KEY: string = '_user_data';
  public POPUP_KEY: string = '_popup_data';
  _cartNeedFresh: boolean = false;  //是否有资料变更需要刷新页面
  _connsignee: any;                 //临时选择的收件人
  _orderConsignee: any;             //临时选择的地区
  _orderCoupons: any;               //临时选择的优惠券

  _CDN_: string = 'http://wanshidingdang.b0.upaiyun.com';//图片CDN地址

  SHARE_LINK: string = 'http://114.55.4.229/sale_info?sale_uuid=';
  _notify_url: string = 'http://v2.tp13.com/v1/alipay';
  _server_name: string = 'LAB218';

    API_Key:string='s28BoZFgLKDGPruBhdsRE0XO';
    Secret_Key:string='3uqYj7NGoYyPZlYUL5kS0TfBPpFB34Gw';
    access_token:string='';//百度AI 有效期30天 需要重新获取

  userDefaultSetting: any;

  defaultBrand: any =
    {
      "name": "OVERDOSE",
      "icon_image": "assets/img/speakers/bear.jpg",
      "dsp": "Overdose is a Best.",
      "id": 30,
    };

  profileModal: Modal;

  constructor(public app: App, public api: ApiService, public storage: Storage, public modalCtrl: ModalController,public events:Events, public platform: Platform) {

    console.log('USER服务初始化');
    this._defaults =
      {
        userbg_image: "/assets/img/userbg.png",
        avatar_image: this._CDN_ + "/avatar/default.gif",
        nickname: "未登录",
        gender: 0,
        gender_text: "unknown",
        dsp: "",
        id: 0,
        age: 0,
        birthtime: 0,
        birthtime_text: "",
        city: "",
        phone: '',
        createtime: 0,
        platform: "",
        platform_text: "",
        updatetime: 0,
        source: "",
        token: "",
        type: "",
        type_text: "",
        status: "",
        status_text: "",
        score: "",
        lng: 0.0000000,
        lat: 0.0000000,
      };
    this.load();



    // url to base64
    const toDataURL = url => fetch(url)
      .then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      }))

    this.bannerBoot({}).subscribe((resp: any) => {
      if (resp.code > 0) {
        for (let i = 0; i < resp.data.length; i++) {
          toDataURL('https://cors-anywhere.herokuapp.com/http://wanshidingdang.b0.upaiyun.com' + resp.data[i].image)
            .then(dataUrl => {
              resp.data[i].base64 = dataUrl;
              // console.log('RESULT:', dataUrl);
              this.storage.set(this.BOOT_IMG_KEY, resp.data);
            })
        }
      }
    }, (err) => {
      console.error(err);
    })
    // url to base64


    this.searchKeywordHot({}).subscribe((resp: any) => {
      console.log('searchKeywordHot', resp);
      if (resp.code > 0) {
        let searchKeywordsArr = resp.data;
        searchKeywordsArr.push({keyword: '華人青年'});
        let randomNum = Math.floor(Math.random() * Math.floor(searchKeywordsArr.length));
        // console.log('========');
        // console.log(searchKeywordsArr);
        // console.log(randomNum);
        this.search_keyword = searchKeywordsArr[randomNum].keyword;
      }
    }, (err) => {
      console.error(err);
    })

    // 极光
    window.document.addEventListener('jpush.receiveRegistrationId', function (event) {
      console.log('开始上报registrationId')

      if (event.registrationId) {
        this.events.publish('user:registrationId', event.registrationId);
        console.log(event.registrationId)

      }
    }, false)
    // 打开极光通知
    /*
    let onOpenNotification = function(event) {
      try {
        let alertContent;
        if (this.platform.is("android")) { // 安卓
          alertContent = event.alert;
        } else {                           // ios
          alertContent = event.aps.alert;
        }
        // 页面跳转
        // here
        console.log("open Notification:" + alertContent);
      } catch (exception) {
        console.log("JPushPlugin:onOpenNotification:" + exception);
      }
    };

    window.document.addEventListener("jpush.openNotification", onOpenNotification, false);
    */
  }



  load() {


    //初始化一些基础配置数据
    this.getConfig({}).subscribe((resp: any) => {
      if (resp.code > 0) {
        this._CDN_ = resp.data.cdn;
        this.SHARE_LINK = resp.data.share_link;
        this._notify_url = resp.data.notify_url;
        this._server_name = resp.data.server_name;
        //
        AppConfig._CDN_ = resp.data.cdn;
        AppConfig.SHARE_LINK = resp.data.share_link;
        AppConfig.NOTIFY_URL = resp.data.notify_url;
        AppConfig.CUSTOMER_SERVICE = resp.data.server_name;
      }
    }, (err) => {

    });

    this.storage.get(this.SETTINGS_KEY).then((value) => {
      if (value) {
        this._user = value;
        if (this._user) this.api.token = this._user.token;
        console.log('读取本地登录数据:');
        console.log(this._user);
        if(this._user.id) {
          console.log('new:notifications');
          let params = {user_id: this._user.id};
          this.userHome(params).subscribe((resp: any) => {
            if (resp.code > 0) {
              // this.userHome = resp.data;
              if (resp.data.letter_count > 0 || resp.data.notification_count > 0) {
                this.events.publish('new:notifications', true);
              } else if (resp.data.letter_count == 0 && resp.data.notification_count == 0) {
                this.events.publish('new:notifications', false);
              }
            }
          }, (err) => {
            this.events.publish('new:notifications', false);
          })
        }
      } else {

        this._user = this._defaults;
        this.save();
        console.log('这是第一次初始化:');
        console.log(this._user);
      }
    });



  }


  save() {
    if (this._user) this.api.token = this._user.token;
    // if (this._user) this.remembphone = this._user.phone;
    if (this._user) AppConfig.REMEMBER_PHONE = this._user.phone;
    this.storage.set(this.SETTINGS_KEY, this._user);
  }


  setValue(key: string, value: any) {
    this._user[key] = value;
    this.storage.set(this.SETTINGS_KEY, this._user);
  }


  getValue(key: string) {
    return this.storage.get(this.SETTINGS_KEY)
      .then(settings => {
        return settings[key];
      });
  }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    let seq = this.api.post('v1/session', accountInfo).share();
    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.code > 0) {
        this._loggedIn(res.data);
      } else {
      }
    }, err => {
      console.error(err);
    });

    return seq;
  }

    /**
     * 获取百度AI token 有效期30天
     * https://aip.baidubce.com/oauth/2.0/token?grant_type=client_credentials&client_id=【百度云应用的AK】&client_secret=【百度云应用的SK】
     */
    baidu_token()
    {
      if(!this.access_token) {
          let seq = this.api.get('http://v2.tp13.com/api/moment.filter/token', {}).share();
          seq.subscribe((res: any) => {
              // If the API returned a successful response, mark the user as logged in
              if (res.code > 0) {
                  console.log(res.data);
                  this.access_token = res.data.access_token;
                  console.log(this.access_token);
              } else {

              }
          }, err => {
              console.error(err);
          });
      }
    }


    /**
     * 获取百度AI token 有效期30天
     */
    spam(text:any) {
        let params = {content: text, access_token: this.access_token};

        let seq = this.api.get('http://v2.tp13.com/api/moment.filter/spam', params).share();
        seq.subscribe((res: any) => {
            // If the API returned a successful response, mark the user as logged in
            if (res.code > 0) {
                console.log(res);
            } else {

            }
        }, err => {
            console.error(err);
        });
        return seq;
    }



  /**
   * 微博登录
   * @param accountInfo
   * @returns {Observable<any>}
   */
  weibologin(accountInfo: any) {
    let seq = this.api.post('v1/weibo', accountInfo).share();
    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.code > 0) {
        this._loggedIn(res.data);
      } else {
      }
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    let seq = this.api.post('v1/user', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.code > 0) {
        this._loggedIn(res.data);
      }
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signupwx(accountInfo: any) {
    let seq = this.api.post('v1/auth', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.code > 0) {
        this._loggedIn(res.data);
      }
    }, err => {
      console.error(err);
    });

    return seq;
  }

  forget(accountInfo: any) {
    let seq = this.api.post('v1/password', accountInfo).share();

    seq.subscribe((res: any) => {
      // If the API returned a successful response, mark the user as logged in
      if (res.code > 0) {

      }
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 加载配置信息
   */
  getSystem(accountInfo: any) {
    let seq = this.api.get('v1/system', accountInfo).share();

    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 加载基础配置
   */
  getConfig(accountInfo: any) {
    let seq = this.api.get('v1/config', accountInfo).share();

    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * 获取联合id
   */
  getUnionID(accountInfo: any) {
    accountInfo.id = 'unionID';
    let seq = this.api.get('v1/auth/unionID', accountInfo).share();

    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 发送验证码
   */
  getRegVCode(accountInfo: any) {
    accountInfo.id = 'reg';
    let seq = this.api.get('v1/vcode/reg', accountInfo).share();

    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 发送验证码
   */
  getVCode(accountInfo: any) {
    accountInfo.id = 'password';
    let seq = this.api.get('v1/vcode/password', accountInfo).share();

    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 经纬度获取城市
   * @param location
   * @returns {Observable<any>}
   * http://api.map.baidu.com/geocoder/v2/?ak=qSzH3krOYsDl9NKGVgDlrecaPPyCRH36&location=39.911013,116.413554&output=json
   */
  geocoderInfo(location: any) {
    console.log(location);
    let seq = this.api.get('v1/geocoder', location).share();
    seq.subscribe((res: any) => {
      console.log(res.data);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 经纬度测算用户的距离
   * @param location
   * 2: "lat1=30.1941575"
   * 3: "lat2=31.2303700"
   * 4: "lng1=120.19817990000001"
   * 5: "lng2=121.4737000"
   * http://api.map.baidu.com/routematrix/v2/driving?output=json&origins=30.1941575,120.19817990000001&destinations=31.2303700,121.4737000&ak=VtQnU9p9LGzGmGFD0PweDa8752LBh4yw
   */
  getDistance(location: any) {
    console.log(location);
    location.id = 'distance';
    let seq = this.api.get('v1/geocoder/distance', location).share();
    seq.subscribe((res: any) => {
      console.log(res.data);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * 获取用户资料
   */
  getUserInfo(accountInfo: any) {
    let seq = this.api.get('v1/profile', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res.data);
      this._user = res.data;
      //修改的数据保存到本地存储
      this.save();

    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 更新用户资料
   */
  updateUserInfo(accountInfo: any) {
    let seq = this.api.post('v1/profile', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 获取用户默认的收货地址
   */
  getDefaultConsignee(accountInfo: any) {
    accountInfo.id = 'default';
    let seq = this.api.get('v1/consignee/default', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 获取用户收货地址
   */
  getConsignee(accountInfo: any) {
    let seq = this.api.get('v1/consignee', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 添加用户收货地址
   */
  getAddConsignee(accountInfo: any) {
    let seq = this.api.post('v1/consignee', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 设置默认收货地址
   */
  setDefaultConsignee(accountInfo: any) {
    accountInfo.id = 'id';
    let seq = this.api.put('v1/consignee/id', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 删除收货地址
   */
  delConsignee(accountInfo: any) {
    accountInfo.id = 'delete';
    let seq = this.api.get('v1/consignee/delete', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * 获取积分可兑换的优惠券
   */
  getScoreCoupons(accountInfo: any) {
    accountInfo.id = 'score';
    let seq = this.api.get('v1/coupon/score', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 积分兑换优惠券
   */
  userScoreCoupon(accountInfo: any) {
    accountInfo.type = 'exchange_coupon';
    let seq = this.api.post('v1/coupon', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * 获取用户的优惠券
   */
  getUserCoupons(accountInfo: any) {
    let seq = this.api.get('v1/coupon', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 获取密码商品
   */
  getPass(accountInfo: any) {
    let seq = this.api.get('v1/SalePass', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  //获取用户收藏的商品
  getUserMarks(params?: any) {
    let seq = this.api.get('v1/mark', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  //搜索商品
  searchSale(params?: any) {
    let seq = this.api.get('v1/search', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  //用户收藏商品/删除收藏
  userMark(params?: any) {
    let seq = this.api.post('v1/mark', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * 本地的地区json数据包
   */
  getAreaData() {
    let seq = this.api.localget("assets/mock-data/area2017.json").share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 获取json数据包
   */
  getAreaConfig() {
    let seq = this.api.get('v1/area').share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 获取banner广告图
   */
  banner(params?: any) {
    let seq = this.api.get('v1/banner', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 登出
   */
  logout() {
    console.log('登出');
    this._user = this._defaults;
    this.save();
    this.needLogin();
  }

  /**
   * 登录
   */
  _loggedIn(resp) {
    console.log(resp);

    this._user = resp;
    //保存到本地
    this.save();
  }

  /**
   * 检查登录
   */
  checkLogin() {

    if (this._user && this._user.hasOwnProperty("id") && this._user.id != 0 && this._user.id != '' && this._user.id != 'undefined') {
      // console.log(this._user);
      return true;
    }
    return false;
  }

  /**
   * 检查登录
   */
  needLogin() {
    console.log("触发登录");
    if (!this.checkLogin()) {
      this.profileModal = this.modalCtrl.create('WelcomePage', {});
      this.profileModal.present();
    }
  }


  goview()
  {

    console.log("触发隐藏");

    let mnav: NavController = <NavController>this.app.getRootNavById("n4");
    //console.log(mnav);
    if (mnav.getActiveChildNavs().length) {
      console.log(this.app.getRootNavById("n4").getActiveChildNavs()[0]);
      let tabs: Tabs = <Tabs>this.app.getRootNavById("n4").getActiveChildNavs()[0].getActiveChildNavs()[0];
      let tab: Tab = <Tab>tabs.getSelected();
      console.log(tab.index);

      let selected: number = tab.index;


      if (selected == 2) {
        tabs.select(0);
      }

      //如果登录成功,则发布刷新事件
        if (this.checkLogin()) {
          this.events.publish('user:logined');
        }


      this.profileModal.dismiss();
    } else {
      mnav.setRoot(MainPage);
    }


  }

  getProfileImageStyle(account: any, bg: boolean = true) {

    let avatar = account ? account.avatar_image : this._CDN_ + "./avatar/default.gif";
    avatar = avatar ? avatar : this._CDN_ + "./avatar/default.gif";
    if (avatar.substr(0, 4) != 'http') {
      avatar = this._CDN_ + avatar;
    }
    if (bg) {
      return 'url(' + avatar + ')'
    } else {
      return avatar;
    }

  }


  getCdnImageStyleMedium(url: string) {
    if (url && url.substr(0, 4) != 'http') {
      return 'url(' + this._CDN_ + url + '_px450)';
    }
    if (!url || url == '') {
      return "url('./assets/img/preload.jpg')";
    }
    return 'url(' + url + ')';
  }


  getCdnAvatar(url: string) {

    if (url && url.substr(0, 4) != 'http') {
      return this._CDN_ + url + '_smallx100';
    }

    return url;
  }

  getCdnImageStyle(url: string) {
    if (url && url.substr(0, 4) != 'http') {
      return 'url(' + this._CDN_ + url + '_px800)';
    }
    if (!url || url == '') {
      return "url('./assets/img/preload.jpg')";
    }
    return 'url(' + url + ')';
  }

  getCdnImage(url: string) {

    if (url && url.substr(0, 4) != 'http') {
      return this._CDN_ + url + '_px800';
    }

    return url;
  }
  getCdnAvatarStyle(url: string) {
    if (url && url.substr(0, 4) != 'http') {
      return 'url(' + this._CDN_ + url + '_smallx100)';
    }
    if (!url || url == '') {
      return "url('./assets/img/preload.jpg')";
    }
    return 'url(' + url + ')';
  }

  /**
   * @param 要转换的毫秒数
   * @return 该毫秒数转换为 * days * hours * minutes * seconds 后的格式
   * @author fy.zhang
   */
  formatDuring(mss: number) {
    let str: string = '';
    let days: number = Math.floor(mss / (1000 * 60 * 60 * 24));
    let hours: number = Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes: number = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds: number = Math.floor((mss % (1000 * 60)) / 1000);
    if (days > 0) str += days + "天";
    str += hours + "时" + minutes + "分" + seconds + "秒";
    return str;
  }

  formatDuring2(mss: number) {
    let str: string = '';
    let days: number = Math.floor(mss / (1000 * 60 * 60 * 24));
    let hours: number = Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes: number = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds: number = Math.floor((mss % (1000 * 60)) / 1000);
    if (days > 0) str += days + "天";
    str += hours + "时" + minutes + "分";
    return str;
  }

  getRefIcon() {
    return 'flash';
  }


  // ------------------------------VIP------------------------------
  // http://www.overdose.com/api/user.vip?user_id=1
  userVip(params?: any) {
    let seq = this.api.get('api/user.vip', {user_id: this._user.id}).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  // ------------------------------第三方绑定------------------------------
  /**
   * 第三方绑定
   * @wechat user_id=1&code=011z31iA0Bh2Re1sophA0f90iA0z31ia
   * @weibo  user_id=1&uid=2450057470&access_token=2.00yrLofC4RnSEB51ad694d65GEYuEE&expires_time=1550775599
   * @param platform
   * @param params
   * @return {Observable<any>}
   */
  user3rdBind(platform: any, params?: any) {
    let seq = this.api.get('api/user.'+platform+'/bind', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // http://www.overdose.com/api/user.wechat/unbind?user_id=1
  /**
   * 第三方解绑
   * @param platform
   * @param params
   * @return {Observable<any>}
   */
  user3rdUnbind(platform: any, params?: any) {
    let seq = this.api.get('api/user.'+platform+'/unbind', {user_id: this._user.id}).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // ------------------------------用户通讯录/用户推荐------------------------------
  /**
   * 通讯录好友
   * http://www.overdose.com/api/user.address_book&user_id=1
   * @param params
   * @return {Observable<any>}
   */
  userAddressBook(params?: any) {
    let seq = this.api.get('api/user.address_book', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 上报通讯录
   * http://www.overdose.com/api/user.address_book/report?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  userAddressBookReport(params: any) {
    let seq = this.api.post('api/user.address_book/report', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 用户推荐
   * http://www.overdose.com/api/user.recommend?user_id=1&start=0&pagesize=10&type=self
   * @param params
   * @return {Observable<any>}
   */
  userRecommend(params?: any) {
    let seq = this.api.get('api/user.recommend', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // ------------------------------用户设置------------------------------
  /**
   * 上报推送ID
   * http://www.overdose.com/api/user.device/report?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  userDeviceReport(params?: any) {
    let seq = this.api.post('api/user.device/report', params).share();
    seq.subscribe((res: any) => {
      console.log('上报成功');
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 用户通知允许设置
   * app推送开关               app_push_switch
   * 短信发送开关               send_sms_switch
   * 允许非关注好友评论通知      allow_not_follow_comment_push
   * 允许非关注好友@通知         allow_not_follow_at_push
   * 只允许我关注的人评论我      only_allow_follow_comment_me
   * 只允许我关注的人@我         only_allow_follow_at_me
   * 不把我推荐给通讯录好友      not_allow_recommend_address_book
   * 不把我推荐给微博好友       not_allow_recommend_weibo
   * 在附近页隐藏我的DOSE       hidden_nearby_moment
   * @param params
   * @return {Observable<any>}
   */
  userSettingSwitch(url: any, params?: any) {
    let seq = this.api.post('api/user.setting/'+url, params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------用户主页------------------------------
  userHome(params?: any) {
    let seq = this.api.get('v1/user/home', {user_id: this._user.id}).share();
    seq.subscribe((res: any) => {
      console.log(res);
      this.userDefaultSetting = res.data;
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------用户通知------------------------------
  /**
   * 用户通知列表
   * http://www.overdose.com/v1/user/notifications?user_id=1&start=0&pagesize=10
   * @param params
   * @return {Observable<any>}
   */
  userNotifications(params?: any) {
    let seq = this.api.get('v1/user/notifications', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 批量标记通知已读
   * http://www.overdose.com/v1/user/notification/read/batch?user_id=1&ids=1,2,3
   * @param params
   * @return {Observable<any>}
   */
  userNotificationReadBatch(params?: any) {
    let seq = this.api.post('v1/user/notification/read/batch', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------用户私信------------------------------

  /**
   * http://www.overdose.com/v1/user/letter/delete?user_id=1&sender_id=2
   * @param params
   * @return {Observable<any>}
   */
  userLetterDelete(params?: any) {
    let seq = this.api.get('v1/user/letter/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 用户私信列表
   * http://www.overdose.com/v1/user/letters?user_id=1&start=0&pagesize=10
   * @param params
   * @return {Observable<any>}
   */
  userLetters(params?: any) {
    let seq = this.api.get('v1/user/letters', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 用户私信对话列表
   * http://www.overdose.com/v1/user/letter/chat/list?&user_id=1&receiver_id=2&start=0&pagesize=10
   * @param params
   * @return {Observable<any>}
   */
  userLettersChatList(params?: any) {
    let seq = this.api.get('v1/user/letter/chat/list', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 发送私信
   * http://www.overdose.com/v1/user/letter/send?user_id=1&receiver_id=2&content=content
   * @param params
   * @return {Observable<any>}
   */
  userLetterSend(params?: any) {
    let seq = this.api.post('v1/user/letter/send', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 好友动态列表
   * http://www.overdose.com/v1/user/dynamic/follows?user_id=1&start=0&pagesize=10&type=friend
   * @param params
   * @return {Observable<any>}
   */
  userDynamicFollows(params?: any) {
    let seq = this.api.get('v1/user/dynamic/follows', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 我的赞
   * http://www.overdose.com/v1/user/likes?user_id=1&start=0&pagesize=10
   * @param params
   * @return {Observable<any>}
   */
  userLikes(params?: any) {
    let seq = this.api.get('v1/user/likes', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------Follow------------------------------
  /**
   * Follow 关注用户
   * http://www.overdose.com/v1/user/follow?user_id=1&follow_id=2
   * @param params
   * @return {Observable<any>}
   */
  userFollow(params?: any) {
    let seq = this.api.get('v1/user/follow', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 指定用户粉丝列表
   * http://www.overdose.com/v1/user/fans?user_id=1&view_user_id=2
   * @param params
   * @return {Observable<any>}
   */
  userFans(params?: any) {
    let seq = this.api.get('v1/user/fans', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 指定用户关注列表
   * http://www.overdose.com/v1/user/follows?user_id=1&view_user_id=2
   * @param params
   * @return {Observable<any>}
   */
  userFollows(params?: any) {
    let seq = this.api.get('v1/user/follows', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------黑名单------------------------------
  /**
   * 用户黑名单列表
   * @param params
   * http://www.overdose.com/api/user.blacklist?user_id=1
   * @return {Observable<any>}
   */
  userBlacklist(params?: any) {
    let seq = this.api.get('api/user.blacklist', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 加入用户黑名单
   * http://www.overdose.com/api/user.blacklist/add?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  userBlacklistAdd(params?: any) {
    let seq = this.api.post('api/user.blacklist/add', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 移除用户黑名单
   * http://www.overdose.com/api/user.blacklist/delete?user_id=1&blacklist_id=1
   * @param params
   * @return {Observable<any>}
   */
  userBlacklistDelete(params?: any) {
    let seq = this.api.get('api/user.blacklist/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 用户黑名单数量
   * http://www.overdose.com/api/user.blacklist/count?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  userBlacklistCount(params?: any) {
    let seq = this.api.get('api/user.blacklist/count', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ------------------------------搜索------------------------------
  /**
   * 文章搜索   search.article
   * 综合搜索   search.index
   * DOSE搜索   search.moment
   * 用户搜索   search.user
   * 商品搜索   search.sale
   * @param type
   * @param params
   * @return {Observable<any>}
   */
  search(type: any, params?: any) {
    let seq = this.api.get('api/search.'+ type, params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // http://www.overdose.com/api/search.keyword/hot?token=e7fa934ba4049f87cc1f112e1cbfe4aa&user_id=1
  /**
   * http://www.overdose.com/api/search.keyword/hot
   * @param params
   * @return {Observable<any>}
   */
  searchKeywordHot(params?: any) {
    let seq = this.api.get('api/search.keyword/hot', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  //
  /**
   * http://www.overdose.com/api/banner.boot?user_id=1
   * @param params
   * @return {Observable<any>}
   */
  bannerBoot(params?: any) {
    let seq = this.api.get('api/banner.boot', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // 排名列表
  // http://www.overdose.com/api/user.ranking?token=e7fa934ba4049f87cc1f112e1cbfe4aa&user_id=1
  userRanking(params?: any) {
    let seq = this.api.get('api/user.ranking', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


}



// WEBPACK FOOTER //
// ./src/providers/data-service/user-service.ts